import { Space, Typography } from "antd";
import { QqOutlined, WechatOutlined, SlackOutlined } from "@ant-design/icons";
import TelegramIcon from "~/components/icons/TelegramIcon";
import DiscordIcon from "~/components/icons/DiscordIcon";

const { Text } = Typography;

const GROUP_KINDS = {
  telegram: { label: "Telegram", icon: <TelegramIcon /> },
  slack: { label: "Slack", icon: <SlackOutlined /> },
  wechat: { label: "微信", icon: <WechatOutlined /> },
  discord: { label: "Discord", icon: <DiscordIcon /> },
  QQ: { label: "QQ", icon: <QqOutlined /> },
}

const GroupKind = ({ group }) => {
  const groupKind = GROUP_KINDS[group.kind] || GROUP_KINDS.wechat;

  return (
    <Text type="secondary">
      <Space size={3}>
        {groupKind.icon}
        {groupKind.label}
      </Space>
    </Text>    
  );
};

export default GroupKind;
